import { Component } from '@angular/core'

@Component({
    selector: 'app-credit-hold-message',
    templateUrl: './credit-hold-message.component.html',
    styleUrls: ['./credit-hold-message.component.scss'],
    standalone: false
})
export class CreditHoldMessageComponent {
  constructor() {}
}
